import { Component, OnInit } from '@angular/core';
import {
  SharingService,
  SharedResource,
  DataTableLazyLoadDataSource,
  ColumnFilter,
  TableAction,
  DataTableLazyLoadRefresher,
  DataTableObservableErrorListener,
  DataTableObservableCompletionListener,
  DataTableColumnData, DataTableConfig, DataTableDataSource
} from '@cas-hub/acabim-common-client';
import {Subscription} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {flatMap} from 'rxjs/internal/operators';

interface SharedResourceTable {
  token: string;
  type: string;
  status: string;
  link: string;
}

export interface ContactTable {
  id: number;
  user_id: string;
  first_name: string;
  last_name: string;
  contactType: string;
  status: string;
  manager: number;
  email: string;
  phone: string;
}

@Component({
  selector: 'acabim-user-shared-resources',
  templateUrl: './shared-resources.component.html',
  styleUrls: ['./shared-resources.component.scss']
})
export class SharedResourcesComponent implements OnInit {

  columnFilters: ColumnFilter[] = [];
  public dataSources: DataTableDataSource<any>[] = [];
  public dataSources2: DataTableDataSource<any>[] = [];
  sharedResources: SharedResource[] = [];
  sharedSub: Subscription = new Subscription();
  totalRecords = 0;

  constructor(
      private readonly sharingService: SharingService
  ) { }

  ngOnInit(): void {
    this.dataSources.push(
        new SharedResourceDataProvider(
            true,
            this.columnFilters,
            [],
            (first, length, sortOrder, sortField, filters) => {
              return this.sharingService.getShared(first, length, sortOrder, sortField, filters).pipe(tap(data => this.totalRecords = data.totalRecords),
                  tap(data => console.log(data)),
                  flatMap(async (result) => this.getSharedTable(result.data)), map(data => ({
                    totalRecords: this.totalRecords,
                    data: (data as SharedResourceTable[])
                  })));
            },
            (tableName: string, error: Error) => {
              console.log('Error in retrieving data in table ', tableName);
            },
            (tableName: string) => {
              console.log('completion');
            }, (action: TableAction) => {
              if (action.id === 0) {
                // this.delete = true;
              }
            }
        )
    );

    // this.sharedSub = this.sharingService.getShared().subscribe((sr: SharedResource[]) => {
    //   if (sr) {
    //     console.dir(sr);
    //     this.sharedResources = sr;
    //   }
    // });
  }
  getSharedTable(data: SharedResource[]): SharedResourceTable[] {
    const currentContactData: SharedResourceTable[] = [];
    data.forEach((d) => {
      const sr: SharedResourceTable = {
        token: d.token,
        type: d.parent_type,
        status: d.status,
        link: d.parent_type + '/' + d.parent_reference
      };
      currentContactData.push(sr);
    });
    return currentContactData;
  }
} // end of class

export class SharedResourceDataProvider extends DataTableLazyLoadDataSource<SharedResourceTable> {

  rowsPerPage = 20;
  stateKey = 'SharedResourceData';

  constructor(
      isFilterEnabled: boolean,
      columnFilters: ColumnFilter[],
      actions: TableAction[],
      refresher: DataTableLazyLoadRefresher<SharedResourceTable>,
      readonly observableErrorListener?: DataTableObservableErrorListener,
      readonly observableCompleteListener?: DataTableObservableCompletionListener,
      readonly actionListener?: (action: TableAction) => void
  ) {
    super(refresher, observableErrorListener, observableCompleteListener);
    this.isFilterEnabled = isFilterEnabled;
    this.columnFilters = columnFilters;
    this.actions = actions;
  }

  isFilterEnabled: boolean;

  readonly columnData: DataTableColumnData[] =
      [
        {
          displayName: 'Token',
          objectPropertyName: 'token',
          colWidth: '10rem'
        },
        {displayName: 'Type', objectPropertyName: 'type', colWidth: '15rem'},
        {displayName: 'Link', objectPropertyName: 'link', colWidth: '10rem'},
        {
          displayName: 'Status',
          objectPropertyName: 'status',
          colWidth: '5rem',
          textAlign: 'center'
        },
      ];

  readonly config: DataTableConfig = {
    tableHeading: 'Shared resources',
    showTableHeading: false,
    isSearchEnabled: true,
    searchPlaceHolder: '',
    emptyMessage: 'No shared resources have been setup or specified',
    globalFilterFields: [],
    hasDetailsButton: true,
    hasCheckbox: true,
    isPaginationEnabled: true,
    isLazyLoadingEnabled: false,
    hasFilters: true,
    isExportEnabled: true,
    hasActions: true,
    datatableUpdateId: 'SharedResourceData'
  };

  readonly columnFilters: ColumnFilter[] = [];

  readonly actions: TableAction[] = [{name: 'Delete', id: 0}];

  onDataExpanded(value: SharedResourceTable): void {
  }

  onAction(action: TableAction): void {
    if (this.actionListener) {
      this.actionListener(action);
    }
  }

}

